import { z } from 'zod/v4';

import { columns, columnValidators } from './columns';

export const lastGrossMarginAdjustmentSchema = z.object(columns);

export type LastGrossMarginAdjustment = z.output<
  typeof lastGrossMarginAdjustmentSchema
>;

export const lastGrossMarginAdjustmentUpdateSchema = z.object(columnValidators);

export type lastGrossMarginAdjustmentUpdate = z.output<
  typeof lastGrossMarginAdjustmentUpdateSchema
>;
